import React, { useState } from 'react';
import { Box, Pagination, Paper, Container, useTheme } from '@mui/material';
import ContactFilters from './ContactFilters';
import ContactTable from './ContactTable';
import useContacts from './useContacts';

const ContactUserList = () => {
  const theme = useTheme();
  const [filters, setFilters] = useState({ name: '', email: '', date: '' });
  const [page, setPage] = useState(1);
  const {
    contacts,
    totalPages,
    fetchContacts,
    selectedContacts,
    setSelectedContacts,
    handleSelect,
    handleDownload,
  } = useContacts(page, filters);

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Paper
        elevation={3}
        sx={{
          p: 4,
          borderRadius: 2,
          backgroundColor: theme.palette.background.paper,
        }}
      >
        {/* Filters Section */}
        <Box
          sx={{
            mb: 4,
            p: 3,
            borderRadius: 1,
            backgroundColor: theme.palette.grey[50],
            boxShadow: theme.shadows[1],
          }}
        >
          <ContactFilters
            filters={filters}
            setFilters={setFilters}
            applyFilters={() => {
              setPage(1);
              fetchContacts();
            }}
            handleDownload={handleDownload}
          />
        </Box>

        {/* Table Section */}
        <Box
          sx={{
            mb: 4,
            overflow: 'hidden',
            borderRadius: 1,
            boxShadow: theme.shadows[2],
          }}
        >
          <ContactTable
            contacts={contacts}
            selectedContacts={selectedContacts}
            handleSelect={handleSelect}
            fetchContacts={fetchContacts}
            setSelectedContacts={setSelectedContacts}
          />
        </Box>

        {/* Pagination Section */}
        <Box
          mt={2}
          display="flex"
          justifyContent="center"
          sx={{
            pt: 2,
            borderTop: `1px solid ${theme.palette.divider}`,
          }}
        >
          <Pagination
            count={totalPages}
            page={page}
            onChange={(e, value) => setPage(value)}
            color="primary"
            shape="rounded"
            size="large"
          />
        </Box>
      </Paper>
    </Container>
  );
};

export default ContactUserList;